/* Standalone Page only: real commerce remains in the native product form. */
(()=>{
  function init(root){
    if(root.srTryonCleanup)root.srTryonCleanup();
    const abort=new AbortController(),on=(el,event,handler)=>el?.addEventListener(event,handler,{signal:abort.signal});
    const dialog=root.querySelector('[data-try-dialog]'),frame=root.querySelector('[data-try-frame]'),documentTemplate=root.querySelector('[data-try-document]');
    if(!dialog||!frame||!documentTemplate)return;
    let opener;
    function close(){dialog.close();}
    root.querySelectorAll('[data-try-open]').forEach(button=>on(button,'click',()=>{
      opener=button;
      const selected=root.querySelector('[data-sr-select]')?.selectedOptions[0]?.textContent||'';
      dialog.querySelector('.blue-note').hidden=!selected.includes('Blue');
      frame.srcdoc=documentTemplate.innerHTML;
      dialog.showModal();document.body.classList.add('try-open');
    }));
    on(root.querySelector('[data-try-close]'),'click',close);on(root.querySelector('[data-try-return]'),'click',close);
    on(dialog,'click',event=>{if(event.target===dialog){const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)close();}});
    function release(){frame.removeAttribute('srcdoc');frame.src='about:blank';document.body.classList.remove('try-open');}
    on(dialog,'close',()=>{release();opener?.focus({preventScroll:true});});
    root.srTryonCleanup=()=>{if(dialog.open)dialog.close();release();abort.abort();delete root.srTryonCleanup;};
  }
  const all=()=>document.querySelectorAll('[data-sr-tryon-page]').forEach(root=>{if(!root.srTryonCleanup)init(root);});
  if(!window.srTryonRegistered){window.srTryonRegistered=true;document.addEventListener('shopify:section:load',all);document.addEventListener('shopify:section:unload',event=>event.target.querySelectorAll('[data-sr-tryon-page]').forEach(root=>root.srTryonCleanup?.()));}
  all();
})();
